/* eslint-disable */
import retina from "retinajs"


// This exports the plugin object.
export default {
    // The install method will be called with the vue constructor as
    // the first argument, along with possible options
    install(vue, options) {
        vue.prototype.$current = null;
        vue.prototype.$sep = '---------------------------------------------------------------------------------\n';

        // 201906141957: Acciones a ser ejecutadas
        vue.prototype.$global = function () {
            const main = function () {
                console.log("Main function!!");
                retina();
            }
            window.addEventListener("load", function (event) {
                main();
            });
            window.addEventListener("resize", function (event) {
                main();
            });
        }

        // 201906141619: Find the closest ancestor with a specific class
        // https://stackoverflow.com/a/27037567
        vue.prototype.$findAncestor = function (el, sel) {
            while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el, sel)));
            return el;
        }

        // 201906121015: Obtiene la fecha formateada
        // https://stackoverflow.com/a/42862926
        vue.prototype.$getFormattedDate = function () {
            // https://stackoverflow.com/a/8888498
            function formatAMPM(date) {
                var hours = date.getHours();
                var minutes = date.getMinutes();
                var ampm = hours >= 12 ? 'p.m.' : 'a.m.';
                hours = hours % 12;
                hours = hours ? hours : 12; // the hour '0' should be '12'
                minutes = minutes < 10 ? '0' + minutes : minutes;
                var strTime = hours + ':' + minutes + ' ' + ampm;
                return strTime;
            }

            function checkZero(data) {
                if (data.length == 1) {
                    data = "0" + data;
                }
                return data;
            }

            var today = new Date();
            var day = today.getDate() + "";
            var month = today.getMonth() + 1 + "";
            var year = today.getFullYear() + "";
            var time = formatAMPM(today);
            day = checkZero(day);
            month = checkZero(month);
            year = checkZero(year);
            return day + "/" + month + "/" + year + " " + time;
        };

        // 201906141145: Detecta el navegador
        // https://stackoverflow.com/a/9851769
        vue.prototype.$getBrowser = function () {
            // Opera 8.0+
            var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
            // Firefox 1.0+
            var isFirefox = typeof InstallTrigger !== 'undefined';
            // Safari 3.0+ "[object HTMLElementConstructor]" 
            var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
            // Internet Explorer 6-11
            var isIE = /*@cc_on!@*/false || !!document.documentMode;
            // Edge 20+
            var isEdge = !isIE && !!window.StyleMedia;
            // Chrome 1 - 71
            var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
            // Blink engine detection
            var isBlink = (isChrome || isOpera) && !!window.CSS;
            return {
                isOpera: isOpera,
                isFirefox: isFirefox,
                isSafari: isSafari,
                isIE: isIE,
                isEdge: isEdge,
                isChrome: isChrome,
                isBlink: isBlink
            };
        };
    }
}
